import i18next from 'i18next'
import React from 'react'
import { none } from 'widgets-for-react'
import { getCookie } from '../../utils/cookies'
import { GenericPageHeader } from '../cmsPage/pages/generic'

export const EmptyLayout = () => (
  <>
    <GenericPageHeader
      notFoundOrEmptyPage={true}
      readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
      title=""
      path={'/'}
      parent={none()}
    />
  </>
)
